import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function MentionsLegales() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Retour à l'accueil
        </button>

        <h1 className="text-4xl font-light text-gray-900 mb-8">Mentions légales</h1>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">Éditeur du site</h2>
            <p className="text-gray-600 leading-relaxed">
              Le site Campaly.com est édité par :<br />
              <strong>Campaly</strong><br />
              12 Rond Point Lepois<br />
              54000 Nancy<br />
              France
            </p>
            <p className="text-gray-600 leading-relaxed">
              Email : <a href="mailto:contact@campaly.com" className="text-gray-900 underline">contact@campaly.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">Hébergement</h2>
            <p className="text-gray-600 leading-relaxed">
              Le site est hébergé par :<br />
              <strong>Netlify, Inc.</strong><br />
              2325 3rd Street, Suite 215<br />
              San Francisco, CA 94107<br />
              États-Unis
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">Propriété intellectuelle</h2>
            <p className="text-gray-600 leading-relaxed">
              L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est la propriété exclusive de Campaly,
              sauf mention contraire. Toute reproduction, distribution, modification, adaptation, retransmission ou
              publication de ces différents éléments est strictement interdite sans l'accord exprès par écrit de Campaly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">Données personnelles</h2>
            <p className="text-gray-600 leading-relaxed">
              Pour en savoir plus sur la collecte et le traitement de vos données personnelles,
              veuillez consulter notre <a href="/politique-confidentialite" className="text-gray-900 underline">Politique de confidentialité</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">Cookies</h2>
            <p className="text-gray-600 leading-relaxed">
              Ce site utilise des cookies techniques nécessaires à son bon fonctionnement.
              En continuant votre navigation, vous acceptez l'utilisation de ces cookies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">Contact</h2>
            <p className="text-gray-600 leading-relaxed">
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter à l'adresse :<br />
              <a href="mailto:contact@campaly.com" className="text-gray-900 underline">contact@campaly.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
